import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import LocalizedDataGrid from "../../../components/LocalizedDataGrid";
import { HEADINGS } from "../meteringGraphql";

const ROW_HEIGHT = 50;
const DEFAULT_PAGE_SIZE = 10;

export default function MeteringTable({ rows, currencySymbol }) {
    const { t } = useTranslation();

    const number = (v) =>
        v.value?.toLocaleString(undefined, { maximumFractionDigits: 0 });

    const columns = [
        { field: "name", headerName: t("Name"), minWidth: 150, flex: 1 },
        {
            field: "heading",
            headerName: t("Type"),
            minWidth: 100,
            flex: 0.5,
            valueFormatter: ({ value }) => t(HEADINGS[value] ?? value),
        },
        {
            field: "consumptionKwh",
            headerName: t("kWh"),
            minWidth: 150,
            flex: 1,
            valueFormatter: number,
        },
        {
            field: "cost",
            headerName: `${t("Cost")} (${currencySymbol})`,
            minWidth: 150,
            flex: 1,
            valueFormatter: number,
        },
        {
            field: "co2Kg",
            headerName: "kgCO2",
            minWidth: 150,
            flex: 1,
            valueFormatter: number,
        },
    ];

    return (
        <Box
            sx={{
                height:
                    ROW_HEIGHT * Math.min(rows.length, DEFAULT_PAGE_SIZE) + 110,
                width: "100%",
            }}
        >
            <LocalizedDataGrid
                rows={rows}
                columns={columns}
                getRowId={(row) => row.id}
                rowHeight={ROW_HEIGHT}
                pageSize={DEFAULT_PAGE_SIZE}
                rowsPerPageOptions={[DEFAULT_PAGE_SIZE, 20, 50, 100]}
            />
        </Box>
    );
}
